import { getAEMUrl, getConfig } from "@jti/fe-common";
export const REPLACE_URL_PLACEHOLDER = "{#loginWithRedirection#}";
export const replaceLoginWithRedirectionUrlPlaceholder = (placeholder) => {
    if (typeof window === "undefined") {
        console.error("window is undefined, returning placeholder");
        return placeholder;
    }
    const encodedRedirectionUrl = encodeURIComponent(window.location.href);
    const linkWithReturnUrl = `${getAEMUrl("#/login", getConfig().AUTH_PAGE_URL)}?returnUrl=${encodedRedirectionUrl}`;
    return linkWithReturnUrl;
};
